<div *ngIf="!db.hide_price_categories" class="mobile_category_list">
  <app-category-list (filter)="get_cat_products($event)"></app-category-list>
</div>

<h6 *ngIf="db.ismobile && db.hide_price_categories" class="bold_name m-0 head_price">Search Results</h6>

<div class="mainwidth" id="content">
  <div class="list-container">
    <div class="side-one">
      <app-category-list (filter)="get_cat_products($event)"></app-category-list>
    </div>
    <!-- (scroll)="!this.db.no_inventory_products ? loadData($event) : null"   #scrollMe (scroll)="onScroll($event)"-->
    <div class="side-two" (scroll)="!this.db.no_price__products ? loadData($event) : null"
      *ngIf="product_list && !db.ismobile" [ngClass]="(is_show_price_detail) ?'active':'side-two'">
      <div *ngIf="db.skeleton_pricing">
        <ion-item *ngFor="let i of [0,1,2,3,4,5,6,7,8,9,10]">
          <ion-label>
            <h3>
              <ion-skeleton-text animated style="width: 50%"></ion-skeleton-text>
            </h3>
            <p>
              <ion-skeleton-text animated style="width: 80%"></ion-skeleton-text>
            </p>
            <p>
              <ion-skeleton-text animated style="width: 60%"></ion-skeleton-text>
            </p>
          </ion-label>
        </ion-item>
      </div>
      <div *ngIf="db.view == 'grid'" class="container normal__grids p0">
        <!-- (click)="add_cart(item,db.plusCount(item.count))" -->
        <div (click)="showProductDetail(item,index)" [ngClass]="{'bdrr':((index + 1 ) % 4)}" class="mouse grid__item"
          *ngFor="let item of product_list; let index = index;">
          <div class="image">
            <!-- <app-cached-image [src]="item.image" [spinner]="true"></app-cached-image> -->
            <img src="{{db.product_img(item.product_image)}}" defaultImage="" alt="">
            <span class="m-0" class="discount" *ngIf="item.discount_percentage">{{item.discount_percentage}}%</span>
          </div>
          <div class="description-container">
            <div class="description">
              <div class="div_">
                <div class="active_inactive" [ngClass]="item.product_status == 'Inactive' ? 'inactive_color' : 'active_color' ">{{item.product_status}}</div>
                <h3 class="bold_name-14 m-0 webkit-text" [style.--line]="2">{{item.product_name | titlecase}}</h3>
                <h4 *ngIf="item.sku" class="small_name sku m-0">SKU : <span>{{item.sku}}</span></h4>
                <h4 *ngIf="item.centre" class="small_name sku m-0">Warehouse : <span>{{item.centre}}</span></h4>
                <!-- <h4 *ngIf="item.modified" class="line_3">  <span class="line_2">Updated On :  </span> {{item.modified | date : 'MMM d, y, h:mm a'}}</h4>   -->
                <h5 *ngIf="item.variants.length != 0" class="variants_ bold_name-12 mouse m-0">
                  <span>{{item.variants.length}}</span> Variants
                </h5>
              </div>
              <ion-button class="add_btn" fill="clear">Edit</ion-button>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="db.view == 'grid_img' " class="container normal__grids p0">
        <!-- (click)="add_cart(item,db.plusCount(item.count))" -->
        <div (click)="showProductDetail(item,index)" [ngClass]="{'bdrr':((index + 1 ) % 4)}" class="mouse grid__item"
          *ngFor="let item of product_list; let index = index;">
          <div class="description-container">
            <div class="description">
              <div class="div_">
                <div class="active_inactive" [ngClass]="item.product_status == 'Inactive' ? 'inactive_color' : 'active_color' ">{{item.product_status}}</div>
                <h3 class="m-0 bold_name-14 webkit-text" [style.--line]="2">{{item.product_name | titlecase}}</h3>
                <h4 *ngIf="item.sku" class="small_name sku m-0">SKU : <span>{{item.sku}}</span></h4>
                <h4 *ngIf="item.centre" class="small_name sku m-0">Warehouse : <span>{{item.centre}}</span></h4>
                <!-- <h4 *ngIf="item.modified" class="line_3">  <span class="line_2">Updated On :  </span> {{item.modified | date : 'MMM d, y, h:mm a'}}</h4>   -->
                <h5 *ngIf="item.variants.length != 0" class="variants_ bold_name-12 m-0 mouse">
                  <span>{{item.variants.length}}</span> Variants
                </h5>
              </div>
              <ion-button class="add_btn" fill="clear">Edit </ion-button>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="db.view == 'list' && !db.skeleton_pricing" class="p0">
        <ion-row class="head mouse">
          <ion-col [size]="db.column_value" class="d__flex list_container p0" [class.active]="item.active"
            *ngFor="let item of product_list; let index = index;" (click)="showProductDetail(item,index)"
            [id]="'product_'+index">
            <ion-item lines="none" style="flex: 0 0 75%;">
              <ion-thumbnail slot="start">
                <!-- {{db.product_img(item.product_image)}} -->
                <img [src]="db.product_img(item.product_image)" defaultImage="" alt="">
              </ion-thumbnail>
              <div>
                <div class="active_inactive" [ngClass]="item.product_status == 'Inactive' ? 'inactive_color' : 'active_color' ">{{item.product_status}}</div>
                <h5 class="line_1 bold_name">{{item.product_name | titlecase}} <span class="line_2"
                    *ngIf="item.variants && item.variants.length > 0">{{item.variants.length}} Variants</span></h5>
                <div class="d__flex gap-10" style="color: #9B9B9B;">
                  <ion-text *ngIf="item.centre" class="line_3">{{item.centre}} </ion-text>
                  <ion-text *ngIf="item.sku" class="line_3"> <span class="line_2">sku : </span> {{item.sku ? item.sku :
                    '-'}}</ion-text>
                  <ion-text class="line_3" *ngIf="item.stock && item.variants && item.variants.length == 0"> <span
                      class="line_2">Stock : </span> {{item.stock}} </ion-text>
                  <!-- <ion-text *ngIf="item.modified" class="line_3">  <span class="line_2">Updated On :  </span> {{item.modified | date : 'MMM d, y, h:mm a'}}</ion-text>   -->
                </div>
              </div>

            </ion-item>
            <div style="flex: 0 0 25%;">
              <p style="font-size: 10px" class="m-0">{{ item.variants.length == 0 ? ' Price : ' : 'Price Range : ' }}
              </p>
              <ion-text class="open_sans__font" style="font-size: 16px">{{ item.price | currency: db.currency
                }}</ion-text>
              <div class="arrow_icon">
                <ion-icon name="chevron-forward-outline"></ion-icon>
              </div>
              <!-- <div class="d__flex gap-10">
                <div class="price_div">
                  <ion-label class="m-0 input_label custom_label">Old</ion-label>
                  <ion-input type="number" name="old"  [(ngModel)]="item.old_price" disabled></ion-input>
                </div>
                <div class="price_div">
                  <ion-label class="m-0 input_label custom_label">New</ion-label>
                  <ion-input type="number" name="new"  [(ngModel)]="item.price" disabled></ion-input>
                </div>
               </div> -->
            </div>
          </ion-col>
        </ion-row>
      </div>

      <app-no-record-found *ngIf="!db.skeleton_pricing && product_list.length == 0" [column]="true"
        height="calc(100vh - 170px)" heading="No Products for selected Category"
        [image]="'assets/no-product-POS.svg'"></app-no-record-found>

      <!-- <div class="colcenter" *ngIf="product_list.length == 0">
        <img src="assets/no-product-POS.svg" alt="">
      </div> -->
    </div>

    <app-no-record-found *ngIf="!db.skeleton_pricing && db.ismobile && product_list.length == 0" [column]="true"
      [height]="db.ismobile ? 'calc(100vh - 280px)' : 'calc(100vh - 112px)'" heading="No Products for selected Category"
      [image]="'assets/no-product-POS.svg'"></app-no-record-found>

    <div *ngIf="db.ismobile && product_list" class="mobile_list">
      <!-- (scroll)="!this.db.no_price__products ? loadData($event) : null"  -->
      <div *ngFor="let item of product_list; let index = index;" class="d__flex just-s align-c list_row"
        (click)="showProductDetail(item,index)">
        <div class="image" style="flex:0 0 18%">
          <img [src]="db.product_img(item.product_image)" defaultImage="" alt="">
        </div>
        <div class="div_" style="flex:0 0 52%;line-height: 16px;">
          <h6 class="m-0 bold_name white_space">{{item.product_name |titlecase}}</h6>
          <h4 *ngIf="item.price" class="small_name sku m-0">Price : <span>{{item.price | number:'1.2-2'}}</span></h4>
          <h4 *ngIf="item.sku" class="small_name sku m-0">SKU : <span>{{item.sku}}</span></h4>
          <h4 *ngIf="item.centre" class="small_name sku m-0">warehouse : <span>{{item.centre}}</span></h4>
          <!-- <h4 *ngIf="item.modified" class="small_name sku m-0">Updated On : <span>{{item.modified | date : 'MMM d, y, h:mm a'}}</span></h4> -->

          <h5 *ngIf="item.variants.length != 0" class="variants_ bold_name-12 mouse m-0">
            <span>{{item.variants.length}}</span> Variants
          </h5>
          <!-- <ion-text class="line_2">{{item.centre}}</ion-text>
              <p class="m-0 line_1">{{item.product_name}}</p>
              <ion-text class="line_3"> SKU <span>{{item.sku}}</span></ion-text>
               <div>
                <ion-text class="line_3">Stock : <span>{{item.centre}}</span></ion-text>  |
                <ion-text class="line_3">{{item.variants.length}} variants</ion-text>
               </div> -->
        </div>
        <div style="flex:0 0 20%">
          <div class="active_inactive" [ngClass]="item.product_status == 'Inactive' ? 'inactive_color' : 'active_color' ">{{item.product_status}}</div>
          <ion-button class="secondary_btn" fill="clear">Edit</ion-button>
        </div>
      </div>
    </div>

    <!-- (submit)="submit.emit()"  (close)="closePriceDetail($event)" -->
    <!-- <div > -->
    <div *ngIf="!db.ismobile && is_show_price_detail" class="side-three active"
      [ngClass]="db.ismobile ? 'slide-top':''">
      <ion-icon class="close" (click)="is_show_price_detail = false" name="close-outline"></ion-icon>
      <app-price-detail *ngIf="db.is_show" [product_detail]="product_detail" [selected_index]="selected_index"
        (submit)="add_price($event)"></app-price-detail>
      <app-price-detail *ngIf="!db.is_show"></app-price-detail>

      <!-- <div class="segment" >
          <div [class.active]="botton_name == 'edit'" (click)="btn_change('edit')" class="mouse btn ion-activatable ripple-parent">Edit Product</div>
          <div [class.active]="botton_name == 'price'" (click)="btn_change('price')" class="mouse btn ion-activatable ripple-parent">Manage Price </div>
        </div>
        <div *ngIf="botton_name == 'edit'"><app-view-product [title]="product_detail" [input_box_width]="'100%'" [is_not_shown]="true"></app-view-product></div>
        <div *ngIf="botton_name == 'price'"><app-price-detail [product_detail]="product_detail"  (submit)="add_price($event)"></app-price-detail></div> -->
    </div>
    <!-- <app-price-detail [product_detail]="product_detail"  (submit)="add_price($event)"></app-price-detail> -->
    <!-- <app-view-product [title]="product_detail" [input_box_width]="'100%'" [is_not_shown]="true"></app-view-product> -->
    <!-- </div> -->
  </div>
</div>